/**
 * Detection helper for the backend "this organisation has switched this off" refusal.
 * When an org turns a domain off in Settings ("What you do"), its public surfaces refuse
 * NEW transactions with 403 errorCode 'ORG_DOMAIN_CLOSED' (class enquiries, trial
 * purchases, re-enrolment, private lesson bookings, ticket sales). The message is the
 * visitor-facing explanation, so callers show it as-is.
 */
const ORG_DOMAIN_CLOSED = 'ORG_DOMAIN_CLOSED';

/**
 * Accepts either a thrown Error (from api wrappers that throw) or an
 * { ok, status, data } response object (from wrappers that return raw responses).
 * @returns {boolean} true when the failure means "the org has switched this off"
 */
export const isOrgDomainClosed = (source) => {
    if (!source) return false;
    return source.errorCode === ORG_DOMAIN_CLOSED
        || source.data?.errorCode === ORG_DOMAIN_CLOSED
        || source.data?.code === ORG_DOMAIN_CLOSED
        || source.data?.error?.code === ORG_DOMAIN_CLOSED;
};
